export default __webpack_public_path__ + "static/media/target.61c1ed6c.svg";